import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContractsCardItemComponent } from './contracts-card-item/contracts-card-item.component';
import { ContractsTextComponent } from './contracts-text/contracts-text.component';
import { ContractsComponent } from './contracts.component';
import { ListRevisionContractsComponent } from './list-revision-contracts/list-revision-contracts.component';
import { ViewRequestComponent } from './view-request/view-request.component';
import { ViewResponseComponent } from './view-response/view-response.component';

const routes: Routes = [
  {path: '', component: ContractsComponent},
  { path: 'detail' , component: ContractsCardItemComponent },
  { path: 'text/:id' , component: ContractsTextComponent },
  { path: 'view-request/:requestId' , component: ViewRequestComponent },
  { path: 'view-response/:requestId/:providerId' , component: ViewResponseComponent },
  { path: 'revision' , component: ListRevisionContractsComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContractsRoutingModule { }
